import React from "react";
import {
  ArrowLeft,
  CheckCircle2,
  MapPin,
  Radar,
  Star,
  X,
} from "lucide-react";

const CaptainSearchingLeftPanel = ({
  onBack,

  isAccepted,
  addTipToFareLoading,

  searchCount,
  MAX_SEARCH_COUNT,
  searchProgress,

  acceptedDriver,
  vehicleIcon,
  selectedVehicle,
  vehicleMeta,

  totalPrice,

  selectedExtra,
  setSelectedExtra,

  extraOptions,
  lastClickedExtra,
  setLastClickedExtra,
  handleExtraClick,
  tipAddedRef,

  formData,

  setShowCancelModal,
}) => {
  return (
    <div className="order-2 flex h-full min-h-0 flex-col overflow-y-auto bg-white px-5 py-6 sm:px-7 lg:order-1 lg:px-7 lg:py-5 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
      <div className="w-full">
         {/* BACK */}
               <button
                 type="button"
                 onClick={onBack}
                 className="mb-3 inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
               >
                 <ArrowLeft size={17} />
                 Back
               </button>

        <div
          className={`mb-3 rounded-2xl px-4 py-3 ${
            isAccepted
              ? "border border-green-100 bg-green-50"
              : "border border-orange-100 bg-orange-50"
          }`}
        >
          <div className="mb-3 flex items-start justify-between gap-3">
            <div>
              <p className="text-[16px] font-bold text-slate-800">
                {isAccepted
                  ? "Captain accepted your order"
                  : `${searchCount} of ${MAX_SEARCH_COUNT} captains searched`}
              </p>

              <p className="mt-1 text-xs text-slate-500">
                {isAccepted
                  ? `${acceptedDriver?.name} accepted your order. Redirecting...`
                  : "Searching nearby captains for your order."}
              </p>
            </div>

            {isAccepted ? (
              <CheckCircle2 size={24} className="text-green-600" />
            ) : (
              <Radar size={24} className="text-orange-500" />
            )}
          </div>

          <div className="h-2 w-full overflow-hidden rounded-full border bg-white">
            <div
              className={`h-full rounded-full transition-all duration-700 ${
                isAccepted ? "bg-green-500" : "bg-orange-400"
              }`}
              style={{
                width: isAccepted ? "100%" : `${searchProgress}%`,
              }}
            />
          </div>
        </div>

        {isAccepted && acceptedDriver && (
          <div className="mb-3 rounded-2xl border border-green-100 bg-white px-4 py-3 shadow-sm">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="flex h-13 w-13 items-center justify-center rounded-full bg-green-100 ring-4 ring-green-50">
                  <img
                    src={vehicleIcon}
                    alt={selectedVehicle}
                    className="h-10 w-10 object-contain"
                  />
                </div>

                <div>
                  <h4 className="font-bold text-slate-900">
                    {acceptedDriver.name}
                  </h4>

                  <div className="mt-1 flex items-center gap-2 text-sm text-slate-500">
                    <span className="inline-flex items-center gap-1">
                      <Star
                        size={14}
                        className="fill-yellow-400 text-yellow-400"
                      />
                      {acceptedDriver.rating}
                    </span>
                    <span>•</span>
                    <span>{acceptedDriver.distance}</span>
                    <span>•</span>
                    <span>{acceptedDriver.eta}</span>
                  </div>
                </div>
              </div>

              <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-bold text-green-700">
                Accepted
              </span>
            </div>
          </div>
        )}

        <div className="mb-3 flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3">
          <div className="flex items-center gap-3">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-orange-300 bg-orange-50">
              <img
                src={vehicleIcon}
                alt={selectedVehicle}
                className="h-11 w-11 object-contain"
              />
            </div>

            <div>
              <h4 className="font-bold text-slate-800">{selectedVehicle}</h4>
              <p className="text-sm text-slate-500">
                Upto {vehicleMeta?.weight || 0} kg
              </p>
            </div>
          </div>

          <div className="text-right">
            <p className="text-sm text-slate-500">Total Price</p>
            <h3 className="text-[20px] font-bold text-slate-900">
              ₹{totalPrice}
            </h3>
          </div>
        </div>

        <div
          className={`mb-3 rounded-2xl border px-4 py-3 ${
            isAccepted
              ? "border-slate-200 bg-slate-50"
              : "border-slate-200 bg-white"
          }`}
        >
          <div className="mb-3 flex items-start justify-between gap-3">
            <div>
              <div className="mb-1 flex items-center gap-2">
                <span className="text-xl">🎯</span>
                <h4 className="font-bold text-slate-800">
                  Increase your chances by adding extra
                </h4>
              </div>

              <p className="text-sm leading-5 text-slate-500">
                {isAccepted
                  ? "Captain accepted this order. Extra fare is locked."
                  : "Add extra fare so captains are more likely to accept your order quickly."}
              </p>
            </div>

            {!isAccepted && selectedExtra > 0 && (
              <button
                type="button"
                onClick={() => {
                  setSelectedExtra(0);
                  setLastClickedExtra(null);
                }}
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200"
              >
                <X size={16} />
              </button>
            )}
          </div>

          <div className="flex flex-wrap gap-3">
            {extraOptions.map((amount) => (
              <button
                key={amount}
                type="button"
                disabled={isAccepted || tipAddedRef.current}
                onClick={() => handleExtraClick(amount)}
                className={`rounded-full px-4 py-2 text-sm font-bold transition ${
                  lastClickedExtra === amount
                    ? "bg-[#1f2d3f] text-white shadow-md"
                    : "bg-blue-50 text-slate-800 hover:bg-blue-100"
                } ${
                  isAccepted ? "cursor-not-allowed opacity-60" : "cursor-pointer"
                }`}
              >
                +₹{amount}
              </button>
            ))}
          </div>

          {selectedExtra > 0 && (
            <div className="mt-3 rounded-xl bg-green-50 px-3 py-2 text-sm text-green-700">
              Extra ₹{selectedExtra} added. New total is <b>₹{totalPrice}</b>.
            </div>
          )}
        </div>

        <div className="mb-3 rounded-2xl border border-slate-200 bg-white">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <h3 className="text-[17px] font-bold text-slate-800">
              Delivery Info
            </h3>

            <button
              type="button"
              onClick={onBack}
              disabled={isAccepted || tipAddedRef.current}
              className={`font-bold text-slate-800 ${
                isAccepted ? "cursor-not-allowed opacity-50" : ""
              }`}
            >
              Edit Address
            </button>
          </div>

          <div className="px-4 py-4">
        <div className="relative flex gap-3">
  {/* Left Timeline */}
  <div className="relative w-6 shrink-0">
    {/* Blue Pin */}
    <span className="absolute left-1/2 top-3 block h-2.5 w-2.5 -translate-x-1/2 rounded-full border-2 border-blue-500 bg-white" />

    {/* Dash */}
    <div className="absolute left-1/2 top-6 bottom-[58px] -translate-x-1/2 border-l-2 border-dashed border-slate-300" />

    {/* Green Pin */}
    <span className="absolute bottom-[44px] left-1/2 flex h-4 w-4 -translate-x-1/2 items-center justify-center rounded-full bg-green-600 text-white">
      <MapPin size={10} fill="currentColor" />
    </span>
  </div>

  {/* Addresses */}
  <div className="flex-1 space-y-3">
    <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2">
      <p className="mb-1 text-[11px] font-bold uppercase tracking-wide text-slate-400">
        From
      </p>

      <p className="break-words text-sm font-medium leading-5 text-slate-700">
        {formData?.pickupAddress || "Pickup address not added"}
      </p>
    </div>

    <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2">
      <p className="mb-1 text-[11px] font-bold uppercase tracking-wide text-slate-400">
        To
      </p>

      <p className="break-words text-sm font-medium leading-5 text-slate-700">
        {formData?.dropAddress || "Drop address not added"}
      </p>
    </div>
  </div>
</div>
          </div>
        </div>
      </div>

      <div className="mt-auto grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
        <button
          type="button"
          disabled={isAccepted || tipAddedRef.current}
          onClick={() => setShowCancelModal(true)}
          className={`rounded-2xl border border-red-100 bg-red-50 py-3 font-bold text-red-600 transition hover:bg-red-100 ${
            isAccepted ? "cursor-not-allowed opacity-50" : ""
          }`}
        >
          Cancel Order
        </button>

        <button
          type="button"
          disabled
          className={`rounded-2xl py-3 font-bold text-white transition ${
            isAccepted
              ? "bg-green-600"
              : "cursor-not-allowed bg-[#2563eb] opacity-80"
          }`}
        >
          {isAccepted ? "Captain Accepted" : "Searching Captain..."}
        </button>
      </div>
    </div>
  );
};

export default CaptainSearchingLeftPanel;